import "./skills.styles.scss";

const skillsData = [
  {
    category: "frontend",
    number: "01",
    technologies: [
      "React",
      "Next.js",
      "TypeScript",
      "JavaScript",
      "HTML5",
      "Redux",
      "GraphQL",
      "Recharts",
    ],
  },
  {
    category: "backend & databases",
    number: "02",
    technologies: ["Node.js", "Python", "PostgreSQL", "MongoDB", "Prisma"],
  },
  {
    category: "styling",
    number: "03",
    technologies: [
      "CSS3",
      "Sass",
      "Tailwind",
      "Styled Components",
      "Framer Motion",
    ],
  },
  {
    category: "tools",
    number: "04",
    technologies: [
      "Git",
      "Webpack",
      "Vite",
      "Jest",
      "React Testing Library",
      "Docker",
      "AWS",
      "Grafana",
      "Jira",
      "Figma",
      "AI & MCP Agents",
    ],
  },
  {
    category: "soft skills",
    number: "05",
    technologies: [
      "proactive",
      "collaborative",
      "highly communicative",
      "problem solver",
    ],
  },
];

export const Skills = () => {
  return (
    <section className="skills">
      {/* Background elements */}
      <div className="skills__bg">
        <div className="skills__blob"></div>
      </div>

      <div className="skills__container">
        {/* Section header */}
        <div className="skills__header">
          <div className="skills__intro">
            <span className="skills__label">What I Work With</span>
            <div className="skills__line"></div>
          </div>

          <h2 className="skills__title">
            <span className="skills__title-line">tech stack</span>
            <span className="skills__title-line">
              <em className="skills__italic">& </em>
              <span className="skills__outline">skills</span>
            </span>
          </h2>
        </div>

        {/* Skills list */}
        <div className="skills__list">
          {skillsData.map((skillGroup, index) => (
            <div key={index} className="skill-row">
              <div className="skill-row__header">
                <span className="skill-row__number">{skillGroup.number}</span>
                <h3 className="skill-row__title">{skillGroup.category}</h3>
              </div>

              <div className="skill-row__divider"></div>

              <ul className="skill-row__tags">
                {skillGroup.technologies.map((tech, techIndex) => (
                  <li key={techIndex} className="skill-row__tag">
                    {tech}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
